/**
 * Crea DDF brand palette — the same four colors used across landing, docs, and
 * portal. Chosen for a warm, real-estate-trustworthy feel that stands out from
 * the typical blue SaaS aesthetic. When this file changes, the equivalent
 * tokens in the landing app's Tailwind config and the docs site's Nextra theme
 * must change too.
 */
export const brand = {
  sage: '#3F756C', // primary — buttons, links, focus rings, active nav
  terracotta: '#C6743E', // accent / CTA emphasis
  cream: '#F6EECD', // warm surfaces (replaces gray-50)
  wheat: '#E1C789', // subtle accents — tags, dividers, hover
  // Semantic / derived
  sageDark: '#2E5751', // hover state for sage
  sageLight: '#5A9388', // disabled / muted sage
  terracottaDark: '#A95E2F', // hover state for terracotta
  ink: '#1F2937', // body text — warm dark gray
  inkMuted: '#6B7280', // secondary text
  warmWhite: '#FAFAF7', // app background (very faint cream tint)
  border: '#E5E1D4', // dividers / borders, warm-neutral
  danger: '#B45439', // destructive — warm red that fits palette
} as const;

/**
 * Ant Design design-token mapping. ConfigProvider consumes this directly.
 * Sage is doubled as the success color since the palette doesn't include a
 * dedicated green — and sage already reads as positive/approving.
 */
export const antTheme = {
  token: {
    colorPrimary: brand.sage,
    colorInfo: brand.sage,
    colorSuccess: brand.sage,
    colorWarning: brand.terracotta,
    colorError: brand.danger,
    colorBgBase: brand.warmWhite,
    colorTextBase: brand.ink,
    colorBorder: brand.border,
    borderRadius: 8,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  components: {
    Layout: {
      headerBg: brand.ink, // dark header for contrast against cream content
      siderBg: '#FFFFFF',
    },
    Menu: {
      itemSelectedBg: brand.cream,
      itemSelectedColor: brand.sageDark,
      itemHoverBg: '#F3EFE3',
    },
    Button: {
      defaultBorderColor: brand.border,
    },
    Card: {
      colorBgContainer: '#FFFFFF',
    },
    Tag: {
      defaultBg: brand.cream,
      defaultColor: brand.sageDark,
    },
  },
};
